import styled from "styled-components";
import { Message } from "./Typography";
import { BrushStrokeBg } from "./Images";

export const SocialLink = styled.a`
  color: white;
  border: 0.15vw solid white;
  border-radius: 50%;
  padding: 0.5rem 0.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: static;
  cursor: pointer;

  transition:
    background-color 0.3s ease-in-out,
    color 0.3s ease-in-out;

  svg {
    font-size: 1.7vw;
  }

  &:hover {
    background-color: white;
    color: ${({ theme }) => theme.colors.red};
  }

  @media (max-width: 48rem) {
    border: 0.11rem solid ${({ theme }) => theme.colors.turquioze};
    color: ${({ theme }) => theme.colors.turquioze};
    position: relative;

    svg {
      font-size: 1.5rem;
    }

    &:hover {
      background-color: ${({ theme }) => theme.colors.turquioze};
      color: white;
    }
  }
`;

export const AddressLink = styled(Message).attrs({ as: "a" })`
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.red};
  }
`;

export const LinkBrushStrokeBg = styled(BrushStrokeBg).attrs({ as: "a" })`
  text-decoration: none;
  cursor: pointer;

  &:hover {
    transform: scale(1.03) rotate(5deg);
  }

  @media (max-width: 48rem) {
    &:hover {
      transform: none;
    }
  }
`;
